export function getDownloadUrl (id) {
  const url = '/web/content/' + id
  return process.env.NODE_ENV === 'development'
    ? 'https://okrtest.funplus.io' + url
    : url
}
